<template>
    <div class="hiq-search-app__header">
        <h1>{{`${translations.searchResultFor} '${query}'`}}</h1>
    </div>
</template>

<script>
export default {
    name: 'header',
    computed: {
        translations() {
            return this.$store.state.translations;
        },
        query() {
            return this.$store.state.searchResult.query;
        }
    }
}
</script>